import React from "react";
import { Carrd } from "./styled";

const CaruselGeneric = ({ children, backImg, width, height }) => {
  return (
    <Carrd  backImg={backImg} width={width} height={height}>
      {children}
    </Carrd>
  );
};

export default CaruselGeneric;
